<footer data-cy="footer">
  <p> Check out the code on <a href="https://github.com/Shaance/minesweeper">GitHub</a></p>
</footer>
